import { rfTempUnitDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback } from "react";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

export const RFTempAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();
    const onNumberFieldChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        chargeDetailVM.onInputTextChange(event, 'rfTemp', chargeBatchUpdate, 'chargeBatchUpdate');
    }, [chargeDetailVM, chargeBatchUpdate]);
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label='RF Temp.'
                        width='150px'
                        fieldName={"rfTemp"}
                        value={chargeBatchUpdate.rfTemp || ''}
                        disabled={false}
                        decimalPlaces={2}
                        allowNegative={true}
                        onChange={(e: any) => onNumberFieldChange(e)}
                    />
                </div>
                <div className='im-flex-row-item' style={{ width: "150px" }}>
                    <NbisCommonField
                        errorMessages={{}}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={chargeBatchUpdate.rfTempUnit ?? ""}
                        fieldValue={chargeBatchUpdate.rfTempUnit}
                        fieldLabel={"RF Temp. Unit"}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'rfTempUnit'}
                        maxLength={60}
                        options={rfTempUnitDropdownOption}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                </div>

            </div>
        </>
    )
}